export default __webpack_public_path__ + "static/loading-6e437fa281cc08819c122febb9f7a708.gif";